import { useState, useEffect } from "react";
import { Loader2, Plus, Check, X, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const inputCls = "w-full bg-[#050505] border border-[#2A2A2A] px-4 py-3 text-white text-sm focus:outline-none focus:border-[#FF4D00] transition-colors";

export default function ExpertiseTab() {
  const [items, setItems] = useState(null);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");
  const load = async () => { const { data } = await api.get("/expertise"); setItems(data.expertise); };
  useEffect(() => { load(); }, []);
  const add = async () => {
    if (!name.trim()) return;
    try { await api.post("/admin/expertise", { name }); setName(""); load(); toast.success("Added"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const save = async (id) => {
    try { await api.put(`/admin/expertise/${id}`, { name: editName }); setEditId(null); load(); toast.success("Updated"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const del = async (id) => {
    if (!window.confirm("Delete this area of expertise?")) return;
    try { await api.delete(`/admin/expertise/${id}`); load(); toast.success("Deleted"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  if (!items) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-[#FF4D00]" /></div>;
  return (
    <div className="max-w-xl" data-testid="expertise-manager">
      <h3 className="font-bebas text-2xl tracking-wide mb-4">AREAS OF EXPERTISE</h3>
      <div className="border border-[#2A2A2A] bg-[#111111] p-4 mb-6 flex gap-3">
        <input data-testid="expertise-add-input" className={inputCls} placeholder="Add an area of expertise…" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} />
        <button data-testid="expertise-add-btn" onClick={add} className="bg-[#FF4D00] text-white px-4 py-2 text-sm hover:bg-[#E64500] transition-colors inline-flex items-center gap-1 whitespace-nowrap"><Plus className="w-4 h-4" /> Add</button>
      </div>
      {!items.length ? (
        <div className="border border-dashed border-[#2A2A2A] p-12 text-center text-sm text-[#A1A1AA]">No areas of expertise yet.</div>
      ) : (
        <div className="border border-[#2A2A2A] divide-y divide-[#2A2A2A]">
          {items.map((it) => (
            <div key={it.id} className="flex items-center justify-between p-4" data-testid={`expertise-item-${it.id}`}>
              {editId === it.id ? (
                <input className={inputCls} value={editName} onChange={(e) => setEditName(e.target.value)} autoFocus />
              ) : (
                <span className="text-white text-sm">{it.name}</span>
              )}
              <div className="flex gap-2 ml-4">
                {editId === it.id ? (
                  <>
                    <button data-testid={`expertise-save-${it.id}`} onClick={() => save(it.id)} className="border border-[#10B981] text-[#10B981] px-2 py-1 hover:bg-[#10B98120] transition-colors"><Check className="w-4 h-4" /></button>
                    <button onClick={() => setEditId(null)} className="border border-[#2A2A2A] text-[#A1A1AA] px-2 py-1 hover:bg-[#1A1A1A] transition-colors"><X className="w-4 h-4" /></button>
                  </>
                ) : (
                  <>
                    <button data-testid={`expertise-edit-${it.id}`} onClick={() => { setEditId(it.id); setEditName(it.name); }} className="border border-[#2A2A2A] text-white px-2 py-1 hover:bg-[#1A1A1A] transition-colors"><Pencil className="w-4 h-4" /></button>
                    <button data-testid={`expertise-delete-${it.id}`} onClick={() => del(it.id)} className="border border-[#EF4444] text-[#EF4444] px-2 py-1 hover:bg-[#EF444420] transition-colors"><Trash2 className="w-4 h-4" /></button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
